import { TYPES } from "./types";
import { sivProductInventoryTransactionService } from "../services";

export const getSIVProductInventoryTransactions = (query) => async (dispatch) => {
  try {
    const result = await sivProductInventoryTransactionService.getSIVProductInventoryTransactions(query);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_SIV_PRODUCT_INVENTORY_TRANSACTIONS_SUCCESS,
        payload: data
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_SIV_PRODUCT_INVENTORY_TRANSACTIONS_FAIL,
        payload: {}
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const getSIVProductInventoryTransactionById = (id) => async (dispatch) => {
  try {
    const result = await sivProductInventoryTransactionService.getSIVProductInventoryTransactionById(id);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_SIV_PRODUCT_INVENTORY_TRANSACTION_BY_ID_SUCCESS,
        payload: { data }
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_SIV_PRODUCT_INVENTORY_TRANSACTION_BY_ID_FAIL,
        payload: {}
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const setSIVProductInventoryTransaction = (transaction) => async (dispatch) => {
  try {
    const result = await sivProductInventoryTransactionService.setSIVProductInventoryTransaction([transaction]);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_SET_SIV_PRODUCT_INVENTORY_TRANSACTION_SUCCESS,
        payload: { data }
      });
    } else {
      dispatch({
        type: TYPES.ACTION_SET_SIV_PRODUCT_INVENTORY_TRANSACTION_FAIL,
        payload: {}
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const updateSIVProductInventoryTransaction = (id, transaction) => async (dispatch) => {
  try {
    const result = await sivProductInventoryTransactionService.updateSIVProductInventoryTransaction(id, transaction);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_UPDATE_SIV_PRODUCT_INVENTORY_TRANSACTION_SUCCESS,
        payload: { data }
      });
    } else {
      dispatch({
        type: TYPES.ACTION_UPDATE_SIV_PRODUCT_INVENTORY_TRANSACTION_FAIL,
        payload: {}
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const deleteSIVProductInventoryTransaction = (id) => async (dispatch) => {
  try {
    const result = await sivProductInventoryTransactionService.deleteSIVProductInventoryTransaction(id);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_DELETE_SIV_PRODUCT_INVENTORY_TRANSACTION_SUCCESS,
        payload: { data }
      });
    } else {
      dispatch({
        type: TYPES.ACTION_DELETE_SIV_PRODUCT_INVENTORY_TRANSACTION_FAIL,
        payload: {}
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const updateSIVProductInventoryTransactionDate = (id, transaction_date) => async (dispatch) => {
  console.log("updateSIVProductInventoryTransactionDate", id, transaction_date);
  try {
    const result = await sivProductInventoryTransactionService.updateSIVProductInventoryTransactionDate(id, transaction_date);
    const data = result.data;
    
    if (data && data.status === 1) {
      dispatch({
        type: TYPES.ACTION_UPDATE_SIV_PRODUCT_INVENTORY_TRANSACTION_DATE_SUCCESS,
        payload: data.data
      });
      return Promise.resolve(data);
    } else {
      dispatch({
        type: TYPES.ACTION_UPDATE_SIV_PRODUCT_INVENTORY_TRANSACTION_DATE_FAIL,
        payload: {}
      });
      return Promise.reject(data);
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
    return Promise.reject(error);
  }
}; 